import * as turf from '@turf/turf';

export const getGeometryAreaHa = (geometry) => {
  if (!geometry || !geometry.coordinates || !geometry.type) {
    return 0;
  }

  try {
    return turf.area({
      type: 'Feature',
      properties: {},
      geometry,
    }) * 0.0001;
  } catch (error) {
    console.error('Error calculating geometry area:', error);
    return 0;
  }
};

export const formatGeometryAreaHa = (geometry, digits = 2) => {
  const area = getGeometryAreaHa(geometry);
  return area.toFixed(digits);
};
